import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

class DocumentiService{

    async getFatture(lingua, token, ev){
        console.log(ev);
        return axios({
            method: 'get',
            url: API_URL + 'Documenti/Documenti', 
            params: {
                codiceLingua: lingua,
                key: ev?.Key,
                
                dtFrom: ev?.DeepFields?.DtDa,
                dtTo: ev?.DeepFields?.DtA,
                tpDoc: ev?.DeepFields?.TpDocum
            },
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            }
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});            
    }

    async getFattura(lingua, token, idFattura){
        return axios({
            method: 'get',
            url: API_URL + 'Documenti/RigheDocumenti', 
            params: {
                codiceLingua: lingua
            },            
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            },
            params:{
                idDoc: idFattura
            }
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});            
    }
}

export default new DocumentiService();